import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ListChecks, ShieldCheck, ScanLine, LogOut, Sun } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

export default function FsmLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="dark bg-[#050B14] min-h-screen">
      <div className="mobile-frame bg-[#050B14] text-[#F8F9FA]" style={{ borderColor: "#1E293B" }}>
        <header className="sticky top-0 z-20 bg-[#050B14] border-b border-[#1E293B] px-5 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#FF5C00] flex items-center justify-center">
              <Sun className="w-4 h-4 text-white" strokeWidth={2.5} />
            </div>
            <div>
              <div className="font-display text-base leading-none font-bold text-white">FSM.</div>
              <div className="font-mono text-[9px] uppercase tracking-[0.25em] text-[#94A3B8] mt-0.5">Field Service</div>
            </div>
          </div>
          <button onClick={async () => { await logout(); nav("/login"); }} data-testid="fsm-logout"
            className="text-[#94A3B8] hover:text-[#FF5C00] p-2">
            <LogOut className="w-4 h-4" />
          </button>
        </header>
        <div className="pb-24">
          <Outlet />
        </div>
        <nav className="fixed bottom-0 left-0 right-0 mx-auto max-w-[480px] bg-[#0A1128]/90 backdrop-blur-xl border-t border-[#1E293B] flex items-center justify-around py-3 z-30">
          <NavLink to="/fsm" end data-testid="fsm-nav-tickets"
            className={({ isActive }) => "flex flex-col items-center gap-1 text-[10px] font-mono uppercase tracking-widest " + (isActive ? "text-[#FF5C00]" : "text-[#94A3B8]")}>
            <ListChecks className="w-5 h-5" /> Tickets
          </NavLink>
          <NavLink to="/fsm/warranty" data-testid="fsm-nav-warranty"
            className={({ isActive }) => "flex flex-col items-center gap-1 text-[10px] font-mono uppercase tracking-widest " + (isActive ? "text-[#FF5C00]" : "text-[#94A3B8]")}>
            <ShieldCheck className="w-5 h-5" /> Warranty
          </NavLink>
          <NavLink to="/fsm/lookup" data-testid="fsm-nav-lookup"
            className={({ isActive }) => "flex flex-col items-center gap-1 text-[10px] font-mono uppercase tracking-widest " + (isActive ? "text-[#FF5C00]" : "text-[#94A3B8]")}>
            <ScanLine className="w-5 h-5" /> Lookup
          </NavLink>
        </nav>
        <Toaster position="top-center" richColors theme="dark" />
      </div>
    </div>
  );
}
